import { ShopVariantType } from "@simplyk/common";

import { Translations } from "@/public/@types/translations";

export interface ShopVariantPreset {
  key: string;
  type: ShopVariantType;
  labelKey: keyof Translations["dashboard"];
  defaultValues?: string[];
}

export const SHOP_VARIANT_PRESETS: ShopVariantPreset[] = [
  {
    key: "size",
    type: ShopVariantType.Size,
    labelKey: "ticketing.variant.size",
    defaultValues: ["XS", "S", "M", "L", "XL"],
  },
  { key: "color", type: ShopVariantType.Color, labelKey: "ticketing.variant.color" },
];

export const MAX_VARIANTS_PER_RATE = 3;
